export default __webpack_public_path__ + "static/media/LOGO-2.8c0caed2.png";